import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "pd-nav" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/palbon_docs/images/palbon-docs-mark.svg",
  alt: "",
  width: "28",
  height: "28"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("PALBON "),
  /*#__PURE__*/_createElementVNode("b", null, "Docs")
], -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "pd-filter" }
const _hoisted_7 = { class: "pd-visually-hidden" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "pd-nav__list" }
const _hoisted_10 = ["aria-expanded", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m9 6 6 6-6 6",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)
const _hoisted_12 = { class: "pd-nav__groups" }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 0,
  class: "pd-nav__group"
}
const _hoisted_15 = ["href", "aria-current"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "pd-nav__brand",
      href: $props.home
    }, _hoisted_5, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("label", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, _toDisplayString($setup.t("Filter the sections")), 1 /* TEXT */),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.filter) = $event)),
        type: "search",
        placeholder: $setup.t('Filter sections and pages'),
        autocomplete: "off"
      }, null, 8 /* PROPS */, _hoisted_8), [
        [_vModelText, $setup.filter]
      ])
    ]),
    _createElementVNode("ul", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visible, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.route,
          class: _normalizeClass(["pd-nav__section", { 'is-open': $setup.isOpen(item), 'is-current': item.route === $props.section }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "pd-nav__toggle",
            "aria-expanded": $setup.isOpen(item),
            onClick: $event => ($setup.toggle(item))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */),
            _hoisted_11
          ], 8 /* PROPS */, _hoisted_10),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              class: _normalizeClass(["pd-nav__overview", { 'is-active': $props.current === item.route }]),
              href: item.route,
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('navigate')))
            }, _toDisplayString($setup.t("Overview")), 11 /* TEXT, CLASS, PROPS */, _hoisted_13),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.groups, (group, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (group.title)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(group.title), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.pages, (page) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: page.route,
                    href: page.route,
                    class: _normalizeClass({ 'is-active': $props.current === page.route }),
                    "aria-current": $props.current === page.route ? 'page' : null,
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('navigate')))
                  }, _toDisplayString(page.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_15))
                }), 128 /* KEYED_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vShow, $setup.isOpen(item)]
          ])
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}